// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"154":"a928341e","626":"f71a273c","640":"2d68efad","729":"5d983dc7"}[chunkId] + ".js";
};